if (Shopify.designMode) {
  window.addEventListener('shopify:block:select', function (event) {
    const activeElements = document.querySelectorAll('.section-interactive-banner .section-interactive-banner__element.active');
    activeElements.forEach(function(element) {
      element.classList.remove('active');
    });
    const selectedBlock = document.querySelector(`.section-interactive-banner__media-element-${event.detail.blockId}`);
    const element = document.querySelector(`.section-interactive-banner__element[data-hover-target='.section-interactive-banner__media-element-${event.detail.blockId}']`);
    element.classList.add("active");
    selectedBlock.classList.add("active");
  });
}


document.addEventListener("DOMContentLoaded", function () {
  let elements = document.querySelectorAll(
    ".section-interactive-banner__element"
  );

  elements.forEach(element => {
    if (element.closest(".section-interactive-banner--standard")) {
      return;
    }

    let innerText = element.innerText;
    element.innerHTML = "";

    let textContainer = document.createElement("div");
    textContainer.classList.add("block");

    let span = document.createElement("span");
    span.innerText = innerText.trim() === "" ? "\xa0" : innerText;
    span.classList.add("word");
    textContainer.appendChild(span);

    element.appendChild(textContainer);
    element.appendChild(textContainer.cloneNode(true));

    let firstBlock = element.querySelector(".block");
    let firstBlockHeight = firstBlock.getBoundingClientRect().height;

    element.style.setProperty(
      "--interactive-banner-element-height",
      `${firstBlockHeight}px`
    );
  });

  //  Refresh page when screen size changes Shopify.designMode is true then not reload page 

      if (window.Shopify && Shopify.designMode) return;

      let resizeTimeout;
      let lastDevice = getDeviceType(window.innerWidth);

      window.addEventListener("resize", onResize);
      // optional: handle orientationchange explicitly (some mobiles trigger orientationchange)
      window.addEventListener("orientationchange", onResize);

      function onResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const currentDevice = getDeviceType(window.innerWidth);

          // Reload only if device category changed (mobile <-> tablet <-> desktop)
          if (currentDevice !== lastDevice) {
            // you can add any cleanup here if needed before reload
            location.reload();
          }

          lastDevice = currentDevice;
        }, 250); // debounce (ms)
      }

      function getDeviceType(width) {
        // mobile: <= 425
        if (width <= 425) return "mobile";
        // tablet: 426 - 768 (inclusive of 768)
        if (width <= 768) return "tablet";
        // desktop: > 768
        if (width > 768) return "desktop";
      }
  });